export const es: Record<string, string> = {
  "common.save": "Guardar",
  "common.cancel": "Cancelar",
  "common.close": "Cerrar",
  "common.loading": "Cargando…",
  "common.search": "Buscar",
  "common.clear": "Limpiar",
  "common.edit": "Editar",
  "common.delete": "Eliminar",
  "common.add": "Agregar",
  "common.previous": "Anterior",
  "common.next": "Siguiente",
  "common.download": "Descargar",
  "common.exportExcel": "Exportar Excel",
  "common.exporting": "Exportando…",
  "common.year": "Año",
  "common.month": "Mes",
  "common.all": "Todos",
  "common.actions": "Acciones",
  "common.name": "Nombre",
  "common.description": "Descripción",
  "common.observation": "Observación",
  "common.quantity": "Cantidad",
  "common.noResults": "No se encontraron resultados.",
  "common.retry": "Reintentar",
  "common.show": "Mostrar",
  "common.hide": "Ocultar",
  "common.refresh": "Actualizar",
  "common.language": "Idioma",
  "common.switchLanguage": "{current}: cambiar a {language}",
  "common.closeDialog": "Cerrar diálogo",
  "common.closeNotification": "Cerrar notificación",
  "common.lightMode": "Cambiar a modo claro",
  "common.darkMode": "Cambiar a modo oscuro",
  "common.bootError": "No se pudo abrir el sistema. Comprueba la conexión y vuelve a cargar la página.",
  "common.requestTimeout": "El servidor está tardando más de lo esperado. Vuelve a intentarlo en unos instantes.",
  "common.connectionError": "No se pudo conectar con el sistema. Comprueba tu conexión y vuelve a intentarlo.",
  "common.operationError": "No se pudo completar la operación.",
  "common.expired": "Tu sesión terminó. Vuelve a ingresar para continuar.",
  "common.loadingPage": "Cargando página",
  "common.notFound": "No encontramos esta página",
  "common.notFoundHelp": "Vuelve al módulo UDRA para continuar.",
  "common.goArticles": "Ir a artículos",
  "common.underDevelopment": "En desarrollo",
  "common.developmentHelp": "Las funcionalidades de este módulo aún no están disponibles.",
  "common.developmentContinue": "Puedes continuar trabajando en los módulos disponibles desde el menú lateral.",
  "common.goDashboard": "Ir a Dashboard",
  "common.reload": "Volver a cargar",
  "shell.title": "Sistema de monitoreo ENAPRES",
  "shell.survey": "ENCUESTA NACIONAL DE PROGRAMAS PRESUPUESTALES",
  "shell.skip": "Saltar al contenido",
  "shell.openMenu": "Abrir menú de módulos",
  "shell.menu": "Menú de módulos",
  "shell.expandMenu": "Expandir menú",
  "shell.collapseMenu": "Contraer menú",
  "shell.accountOptions": "Opciones de {name}",
  "shell.administration": "Administración UDRA",
  "shell.administrator": "Administrador",
  "shell.account": "Opciones de cuenta",
  "shell.about": "Acerca del sistema",
  "shell.signingOut": "Cerrando…",
  "shell.signOut": "Cerrar sesión",
  "shell.closeModuleMenu": "Cerrar menú de módulos",
  "shell.modules": "Módulos del sistema",
  "shell.workspace": "ESPACIO DE TRABAJO",
  "shell.closeMenu": "Cerrar menú",
  "shell.collapseDashboard": "Contraer secciones de Dashboard",
  "shell.expandDashboard": "Expandir secciones de Dashboard",
  "shell.segmentation": "Segmentación",
  "shell.institute": "Instituto Nacional de Estadística e Informática",
  "shell.aboutDashboard": "Consulta la programación de viviendas y conglomerados por sede operativa desde Dashboard.",
  "shell.aboutUdra": "En UDRA puedes administrar artículos, registrar movimientos y gestionar su asignación al personal.",
  "shell.understood": "Entendido",
  "shell.udraSections": "Secciones UDRA",
  "shell.itemManagement": "Gestión de artículos",
  "shell.maintenance": "Mantenimiento",
  "shell.income": "Ingresos",
  "shell.outgoing": "Salidas",
  "shell.assignment": "Asignación",
  "shell.catalogs": "Catálogos",
  "shell.items": "Artículos",
  "shell.access": "Acceso",
  "shell.recover": "Recuperar acceso",
  "shell.reset": "Restablecer contraseña",
  "shell.metaDescription": "Sistema de monitoreo ENAPRES. Programación y segmentación, gestión de artículos, movimientos y asignaciones.",
  "auth.connection": "No se pudo establecer conexión con el sistema. Vuelve a intentarlo.",
  "auth.survey": "Encuesta Nacional de Programas Presupuestales",
  "auth.monitoring": "MONITOREO ENAPRES",
  "auth.storyTitle": "Gestión y seguimiento del operativo ENAPRES.",
  "auth.storyDescription": "Información de campo, recursos y supervisión en un mismo espacio de trabajo.",
  "auth.building": "Sede del Instituto Nacional de Estadística e Informática",
  "auth.peru": "ENAPRES · Perú",
  "auth.access": "ACCESO AL SISTEMA",
  "auth.loginTitle": "Inicia sesión",
  "auth.recoverTitle": "Recupera tu acceso",
  "auth.loginDescription": "Ingresa tus credenciales para continuar.",
  "auth.recoverDescription": "Solicita asistencia para volver a ingresar al sistema.",
  "auth.username": "Usuario",
  "auth.password": "Contraseña",
  "auth.usernamePlaceholder": "Ingresa tu usuario",
  "auth.passwordPlaceholder": "Ingresa tu contraseña",
  "auth.forgot": "¿Olvidaste tu contraseña?",
  "auth.signingIn": "Ingresando…",
  "auth.signIn": "Ingresar",
  "auth.authorized": "Acceso exclusivo para usuarios autorizados.",
  "auth.restore": "Restablecimiento de acceso",
  "auth.contact": "Contacta al administrador del sistema para restablecer tu contraseña.",
  "auth.usernameHelp": "Ten a mano tu nombre de usuario para facilitar la atención.",
  "auth.back": "Volver al inicio de sesión",
  "auth.help": "¿Necesitas ayuda para acceder?",
  "auth.accountAdmin": "Contacta al administrador de tu cuenta ENAPRES.",
  "auth.portal": "Portal institucional INEI",
  "modules.udra.name": "UDRA",
  "modules.udra.description": "Gestión de recursos y artículos.",
  "modules.udra.footer": "UDRA · Gestión de recursos y artículos",
  "modules.dashboard.name": "Dashboard",
  "modules.dashboard.description": "Programación y segmentación de la encuesta.",
  "modules.dashboard.footer": "Dashboard · Programación y segmentación",
  "modules.documentos-metodologicos.name": "Documentos metodológicos",
  "modules.documentos-metodologicos.description": "Documentación y lineamientos metodológicos de la encuesta.",
  "modules.documentos-metodologicos.footer": "Documentos metodológicos · Biblioteca documental ENAPRES",
  "modules.operacion-campo.name": "Operación de campo",
  "modules.operacion-campo.description": "Organización y consulta de la operación de campo.",
  "modules.operacion-campo.footer": "Operación de campo · En desarrollo",
  "modules.indicadores-cobertura.name": "Indicadores de cobertura",
  "modules.indicadores-cobertura.description": "Consulta de indicadores de cobertura de la encuesta.",
  "modules.indicadores-cobertura.footer": "Indicadores de cobertura · En desarrollo",
  "modules.indicadores-calidad.name": "Indicadores de calidad",
  "modules.indicadores-calidad.description": "Consulta de indicadores de calidad de la encuesta.",
  "modules.indicadores-calidad.footer": "Indicadores de calidad · En desarrollo",
  "modules.indicadores-ppr.name": "Indicadores de PPR",
  "modules.indicadores-ppr.description": "Consulta de indicadores de programas presupuestales.",
  "modules.indicadores-ppr.footer": "Indicadores de PPR · En desarrollo",
  "modules.evaluacion-muestra.name": "Evaluación de la muestra",
  "modules.evaluacion-muestra.description": "Consulta de la evaluación de la muestra de la encuesta.",
  "modules.evaluacion-muestra.footer": "Evaluación de la muestra · En desarrollo",
  "modules.seguimiento-monitoreo.name": "Seguimiento y monitoreo",
  "modules.seguimiento-monitoreo.description": "Seguimiento del desarrollo del operativo ENAPRES.",
  "modules.seguimiento-monitoreo.footer": "Seguimiento y monitoreo · En desarrollo",
  "modules.consistencia.name": "Consistencia",
  "modules.consistencia.description": "Revisión de la consistencia de la información de la encuesta.",
  "modules.consistencia.footer": "Consistencia · En desarrollo",
  "modules.supervision.name": "Supervisión",
  "modules.supervision.description": "Consulta y gestión de la supervisión del operativo.",
  "modules.supervision.footer": "Supervisión · En desarrollo",
  "modules.banco-preguntas.name": "Banco de preguntas",
  "modules.banco-preguntas.description": "Organización de las preguntas de la encuesta.",
  "modules.banco-preguntas.footer": "Banco de preguntas · En desarrollo"
};

export const en: Record<string, string> = {
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.loading": "Loading…",
  "common.search": "Search",
  "common.clear": "Clear",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.add": "Add",
  "common.previous": "Previous",
  "common.next": "Next",
  "common.download": "Download",
  "common.exportExcel": "Export Excel",
  "common.exporting": "Exporting…",
  "common.year": "Year",
  "common.month": "Month",
  "common.all": "All",
  "common.actions": "Actions",
  "common.name": "Name",
  "common.description": "Description",
  "common.observation": "Notes",
  "common.quantity": "Quantity",
  "common.noResults": "No results found.",
  "common.retry": "Retry",
  "common.show": "Show",
  "common.hide": "Hide",
  "common.refresh": "Refresh",
  "common.language": "Language",
  "common.switchLanguage": "{current}: switch to {language}",
  "common.closeDialog": "Close dialog",
  "common.closeNotification": "Dismiss notification",
  "common.lightMode": "Switch to light mode",
  "common.darkMode": "Switch to dark mode",
  "common.bootError": "The system could not be opened. Check your connection and reload the page.",
  "common.requestTimeout": "The server is taking longer than expected. Please try again shortly.",
  "common.connectionError": "Could not connect to the system. Check your connection and try again.",
  "common.operationError": "The operation could not be completed.",
  "common.expired": "Your session has expired. Sign in again to continue.",
  "common.loadingPage": "Loading page",
  "common.notFound": "Page not found",
  "common.notFoundHelp": "Return to the UDRA module to continue.",
  "common.goArticles": "Go to items",
  "common.underDevelopment": "Under development",
  "common.developmentHelp": "The features in this module are not available yet.",
  "common.developmentContinue": "You can continue working in the available modules from the sidebar.",
  "common.goDashboard": "Go to dashboard",
  "common.reload": "Reload",
  "shell.title": "ENAPRES monitoring system",
  "shell.survey": "NATIONAL SURVEY OF BUDGET PROGRAMS",
  "shell.skip": "Skip to content",
  "shell.openMenu": "Open module menu",
  "shell.menu": "Module menu",
  "shell.expandMenu": "Expand menu",
  "shell.collapseMenu": "Collapse menu",
  "shell.accountOptions": "Options for {name}",
  "shell.administration": "UDRA administration",
  "shell.administrator": "Administrator",
  "shell.account": "Account options",
  "shell.about": "About the system",
  "shell.signingOut": "Signing out…",
  "shell.signOut": "Sign out",
  "shell.closeModuleMenu": "Close module menu",
  "shell.modules": "System modules",
  "shell.workspace": "WORKSPACE",
  "shell.closeMenu": "Close menu",
  "shell.collapseDashboard": "Collapse dashboard sections",
  "shell.expandDashboard": "Expand dashboard sections",
  "shell.segmentation": "Segmentation",
  "shell.institute": "National Institute of Statistics and Informatics",
  "shell.aboutDashboard": "Use the dashboard to review dwelling and cluster scheduling by operational office.",
  "shell.aboutUdra": "Use UDRA to manage items, record stock movements and allocate items to staff.",
  "shell.understood": "Got it",
  "shell.udraSections": "UDRA sections",
  "shell.itemManagement": "Item management",
  "shell.maintenance": "Maintenance",
  "shell.income": "Stock receipts",
  "shell.outgoing": "Stock issues",
  "shell.assignment": "Allocation",
  "shell.catalogs": "Catalogs",
  "shell.items": "Items",
  "shell.access": "Sign in",
  "shell.recover": "Recover access",
  "shell.reset": "Reset password",
  "shell.metaDescription": "ENAPRES monitoring system. Scheduling and segmentation, item management, stock movements and allocations.",
  "auth.connection": "Could not connect to the system. Please try again.",
  "auth.survey": "National Survey of Budget Programs",
  "auth.monitoring": "ENAPRES MONITORING",
  "auth.storyTitle": "Manage and monitor ENAPRES operations.",
  "auth.storyDescription": "Field information, resources and supervision in one workspace.",
  "auth.building": "Headquarters of the National Institute of Statistics and Informatics",
  "auth.peru": "ENAPRES · Peru",
  "auth.access": "SYSTEM ACCESS",
  "auth.loginTitle": "Sign in",
  "auth.recoverTitle": "Recover your access",
  "auth.loginDescription": "Enter your credentials to continue.",
  "auth.recoverDescription": "Request assistance to regain access to the system.",
  "auth.username": "Username",
  "auth.password": "Password",
  "auth.usernamePlaceholder": "Enter your username",
  "auth.passwordPlaceholder": "Enter your password",
  "auth.forgot": "Forgot your password?",
  "auth.signingIn": "Signing in…",
  "auth.signIn": "Sign in",
  "auth.authorized": "Access is restricted to authorized users.",
  "auth.restore": "Restoring access",
  "auth.contact": "Contact the system administrator to reset your password.",
  "auth.usernameHelp": "Have your username ready to help the administrator assist you.",
  "auth.back": "Back to sign in",
  "auth.help": "Need help signing in?",
  "auth.accountAdmin": "Contact your ENAPRES account administrator.",
  "auth.portal": "INEI institutional portal",
  "modules.udra.name": "UDRA",
  "modules.udra.description": "Resource and item management.",
  "modules.udra.footer": "UDRA · Resource and item management",
  "modules.dashboard.name": "Dashboard",
  "modules.dashboard.description": "Survey scheduling and segmentation.",
  "modules.dashboard.footer": "Dashboard · Scheduling and segmentation",
  "modules.documentos-metodologicos.name": "Methodological documents",
  "modules.documentos-metodologicos.description": "Survey methodology documents and guidelines.",
  "modules.documentos-metodologicos.footer": "Methodological documents · ENAPRES document library",
  "modules.operacion-campo.name": "Field operations",
  "modules.operacion-campo.description": "Organization and review of field operations.",
  "modules.operacion-campo.footer": "Field operations · Under development",
  "modules.indicadores-cobertura.name": "Coverage indicators",
  "modules.indicadores-cobertura.description": "Review of survey coverage indicators.",
  "modules.indicadores-cobertura.footer": "Coverage indicators · Under development",
  "modules.indicadores-calidad.name": "Quality indicators",
  "modules.indicadores-calidad.description": "Review of survey quality indicators.",
  "modules.indicadores-calidad.footer": "Quality indicators · Under development",
  "modules.indicadores-ppr.name": "Budget program indicators",
  "modules.indicadores-ppr.description": "Review of budget program indicators.",
  "modules.indicadores-ppr.footer": "Budget program indicators · Under development",
  "modules.evaluacion-muestra.name": "Sample evaluation",
  "modules.evaluacion-muestra.description": "Review of survey sample evaluation.",
  "modules.evaluacion-muestra.footer": "Sample evaluation · Under development",
  "modules.seguimiento-monitoreo.name": "Monitoring and follow-up",
  "modules.seguimiento-monitoreo.description": "Monitoring of ENAPRES field operations.",
  "modules.seguimiento-monitoreo.footer": "Monitoring and follow-up · Under development",
  "modules.consistencia.name": "Consistency",
  "modules.consistencia.description": "Review of survey data consistency.",
  "modules.consistencia.footer": "Consistency · Under development",
  "modules.supervision.name": "Supervision",
  "modules.supervision.description": "Review and management of field supervision.",
  "modules.supervision.footer": "Supervision · Under development",
  "modules.banco-preguntas.name": "Question bank",
  "modules.banco-preguntas.description": "Organization of survey questions.",
  "modules.banco-preguntas.footer": "Question bank · Under development"
};
